// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__IsQTw","truncatedText":"styles_truncatedText__nFXwd","fullText":"styles_fullText__fxYp2","textContainer":"styles_textContainer__DW_BY"};